import { Box, DialogActions, DialogContentText, DialogTitle, Grid, Modal, Tooltip, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import RHFSelector from 'src/components/hook-form/RHFSelector';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import validation from './validation';
import { useMutationCustom, useQueryCustom } from 'src/utils/reactQueryHooks';
import axiosInstance from 'src/utils/axios';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import WaitingBox from 'src/components/WaitingBox/index';
import persianToEnglishNumber from 'src/utils/persianToEnglishNumber';
import api from 'src/services/api';
import { useEffect, useMemo, useRef, useState } from 'react';
import { acceptFinallyStatus, documentStatus, sabtNahayiStatus, travelTypeObject } from 'src/enumeration';
import { useSelector } from 'react-redux';
import buildAccess from 'src/permission/buildAccess';
import { hasAccess } from 'src/permission/utiles';
import CaravanSelector from '../../../../../caravansManagement/selector';
import { PATH_DASHBOARD } from '../../../../../../routes/paths';
import SelectBed from '../../../../../caravansManagement/Show/Client/SelectBed';
import { CLIENT_TYPE_OP, DUTY_SENDING_STATUS, HAJ_STATUS, PASSPORT_SENDING_STATUS } from 'src/config';
import RHFDatePicker from 'src/components/hook-form/RHFDatePicker';
import { fDateForApi } from 'src/utils/formatTime';
import ModalLayout from 'src/components/ModalLayout';
import QuestionComponent from 'src/components/ui/Question';

const UserStatusInfo = ({ data , travelType = "" }) => {
  const admin = useSelector((store) => store.admin.data);
  const accessStatus = buildAccess("Status");

  const confirmSubmitHajStatusModal = useRef();


  const [searchParams] = useSearchParams();

  const { t } = useTranslation();
  const queryParams = useParams();
  const paramId = queryParams?.id;
  const travelId = queryParams?.course;
  // console.log({ queryParams,travelId });
  const navigate = useNavigate();

  const isAttabat = useMemo(() =>
          [travelTypeObject.atabat_aliat.value].includes(travelType)
          , [travelType])

  const [toggleModal, setToggleModal] = useState();

  const [UserStatusInfoData, setUserStatusInfoData] = useState({})
  const [JustSendPassport, setJustSendPassport] = useState(false)
  const [SendJustHajStatus, setSendJustHajStatus] = useState(false)

  const handleSetModalData = (data) => setToggleModal(data);
  const handleToggleModal = () => setToggleModal((p) => !p);

  const [HasCaravan, setHasCaravan] = useState(false)


  const handleQuestionModal = (params) => confirmSubmitHajStatusModal.current.show((p) => !p, params);



  const methods = useForm({
    resolver: yupResolver(validation.schema()),
    defaultValues: validation.defaultValues
  });

  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
  } = methods;

  // ----------------------------------------------------------------------------- SERVICE
  const creating = (params) => axiosInstance.post(api.changeStatus.base, params, { params: { travel_id: searchParams.get("travel") } });
  const creatingCaravan = (params) => axiosInstance.post(api.caravan.client, params, { params: { travel_id: searchParams.get("travel") } });
  const updating = (params) => axiosInstance.post(`${api.changeStatus.base}`, params, { params: { travel_id: searchParams.get("travel") } });
  const getById = () => axiosInstance.get(`${api.changeStatus.base}?travel_register_id=${queryParams.course}`);

  // ------------------------------------------------------------------------------ Mutation
  const onSuccessMutating = () => {
    toast.success(t('successfully'));
    if (JustSendPassport) {
      // console.log({JustSendPassport})

      // setJustSendPassport(false)
    }
    // navigate(PATH_DASHBOARD.visitorManagement.root("omre", searchParams.get("travel")) + "/registrations")
  };
  // const onErrorMutating = (error) => {
  //   console.log('* * * onErrorMutating :', { error });
  //   const errorTitle = error.response.data.message || t('errorTryAgain');
  //   const errors = Object.values(error?.response?.data?.errors || {});
  //   if (errors?.length) {
  //     errors?.map((x) => {
  //       return toast.error(x?.[0]);
  //     });
  //   } else toast.error(errorTitle);
  // };
  const { isLoading, mutate } = useMutationCustom({
    url: paramId ? updating : creating,
    name: `${api.changeStatus.base}_update`,
    // invalidQuery: `${api.travelRegister.register.base}_get_${queryParams.course}`,
    invalidQuery: `${api.public.travelRegister.base}_getById_userStatus`,
    onSuccess: onSuccessMutating,
    onError: () => {
      setJustSendPassport(false)
    },
  });
  const { isLoading: justHasStatusLoading, mutate: hajStatusMutate } = useMutationCustom({
    url: paramId ? updating : creating,
    name: `${api.changeStatus.base}_update`,
    // invalidQuery: `${api.travelRegister.register.base}_get_${queryParams.course}`,
    invalidQuery: `${api.public.travelRegister.base}_getById_userStatus`,
    onSuccess: () => {
      handleQuestionModal()
    },
    onError: () => {
      // setJustSendPassport(false)
    },
  });


  // ---------------------------------------
  const onSuccess = (resData) => {
    // console.log('* * * onSuccess', { resData });

    if (JustSendPassport) {
      setJustSendPassport(false)
      setUserStatusInfoData(old => {
        const newOld = {
          ...old, register: {
            ...old?.register,
            passport_sending_status_num: 1
          }
        }

        return newOld

      })
      return;
    }

    const resetData = {
      [validation.fieldNames.status]: acceptFinallyStatus[resData?.register?.status_num],
      [validation.fieldNames.sabt_nahayi_status]: sabtNahayiStatus[resData?.register?.sabt_nahayi_status_num],
      [validation.fieldNames.bankStatus]: documentStatus[resData?.register?.bank_status_num],
      [validation.fieldNames.dutyStatus]: documentStatus[resData?.register?.duty_status_num],
      [validation.fieldNames.identityStatus]: documentStatus[resData?.register?.identity_status_num],
      [validation.fieldNames.passport_sending_status]: PASSPORT_SENDING_STATUS[resData?.register?.passport_sending_status_num],
      [validation.fieldNames.duty_sending_status]: DUTY_SENDING_STATUS[resData?.register?.duty_sending_status_num],
      ...(resData?.register?.duty_from && {
        [validation.fieldNames.duty_from]: new Date(resData?.register?.duty_from),
      }),
      ...(resData?.register?.duty_to && {
        [validation.fieldNames.duty_to]: new Date(resData?.register?.duty_to),
      }),
      [validation.fieldNames.haj_status]: HAJ_STATUS[resData?.register?.haj_status_num],
      [validation.fieldNames.carevan]: resData?.team?.id ? CaravanSelector.convertor.object(resData?.team) : null,
      [validation.fieldNames.type]: CLIENT_TYPE_OP.find(item => item.value === resData?.register?.client?.type),
      [validation.fieldNames.code]: resData?.register?.code,
      [validation.fieldNames.description]: resData?.register?.description,
    };

    if (resData?.team?.id) {
      setHasCaravan(true)
    } else {
      setHasCaravan(false)
    }

    setUserStatusInfoData(resData)

    console.log('* * * onSuccess', { resetData });
    reset(resetData);
  };

  const userStatus = useQueryCustom({
    url: getById,
    name: `${api.public.travelRegister.base}_getById_userStatus`,
    // params: { id: travel },
    // invalidQuery: `${Enum?.api?.base}_get_${id}_${travel}`,
    onSuccess: (resData) => {
      onSuccess(resData?.data)
    },
    enabled: hasAccess(accessStatus.read)
    //  onError: onErrorMutating,
  });

  useEffect(() => {
    if (!data) return;
    onSuccess(data);
  }, [data]);
  // const watchStartDate = watch(validation.fieldNames.startDate);
  const watchStatusData = watch(validation.fieldNames.status);
  // const watchSendPassport = watch(validation.fieldNames.passport_sending_status);
  // console.log({ watchStartDate });
  const onSubmit = async () => {
    const values = getValues();
    console.log('* * * onSubmit : ', { values });

    const reqData = {
      travel_register_id: travelId,
      [validation.fieldNames.status]: values[validation.fieldNames.status]?.value,
      [validation.fieldNames.sabt_nahayi_status]: values[validation.fieldNames.sabt_nahayi_status]?.value,
      // [validation.fieldNames.bankStatus]: values[validation.fieldNames.bankStatus]?.value,
      [validation.fieldNames.dutyStatus]: values[validation.fieldNames.dutyStatus]?.value,
      [validation.fieldNames.identityStatus]: values[validation.fieldNames.identityStatus]?.value,
      [validation.fieldNames.type]: values[validation.fieldNames.type]?.value,
      [validation.fieldNames.passport_sending_status]: values[validation.fieldNames.passport_sending_status]?.value,
      [validation.fieldNames.duty_sending_status]: values[validation.fieldNames.duty_sending_status]?.value,

      [validation.fieldNames.duty_from]: values[validation.fieldNames.duty_from] ? persianToEnglishNumber(
        fDateForApi(values[validation.fieldNames.duty_from])
      ) : undefined,

      [validation.fieldNames.duty_to]: values[validation.fieldNames.duty_to] ? persianToEnglishNumber(
        fDateForApi(values[validation.fieldNames.duty_to])
      ) : undefined,

      // [validation.fieldNames.haj_status]: UserStatusInfoData?.register?.haj_status_num == values[validation.fieldNames.haj_status]?.value ? undefined : values[validation.fieldNames.haj_status]?.value,
      // [validation.fieldNames.haj_status]: values[validation.fieldNames.haj_status]?.value,
      [validation.fieldNames.code]: values[validation.fieldNames.code],
      [validation.fieldNames.description]: values[validation.fieldNames.description],
    };

    console.log('* * * onSubmit : ', { reqData, values });
    mutate(reqData);
  };

  const onSuccessMutatingCaravan = () => {
    toast.success(t('successfully'));
    setToggleModal(false);
    // navigate(backUrl);
  };

  const mutateAdd = useMutationCustom({
    url: creatingCaravan,
    name: `user_status_caravan_update`,
    // invalidQuery: `${Enum?.api?.base}_get_${queryParams.travel}_${queryParams.id}`,
    invalidQueries: [
      `${api.public.travelRegister.base}_getById_userStatus`
    ],

    // invalidQuery: `${Enum?.api?.base}_get`,
    onSuccess: onSuccessMutatingCaravan,
    // onError: onErrorMutating,
  });

  const onSubmitCaravan = async (bed) => {
    console.log("onSubmitCaravan")
    const userData = userStatus?.data?.data?.register;
    const selectedCarevan = getValues(validation.fieldNames.carevan)?.data;

    const reqData = {
      team_id: selectedCarevan.id,
      clients: [
        {
          id: userData?.client?.id,
          bed: bed
        }
      ]
    };

    console.log({ reqData })

    const formData = new FormData();
    Object.keys(reqData || {})?.map((x) => {
      formData.append(x, reqData[x]);
    });

    mutateAdd.mutate(reqData);

  }

  const handleSelectBed = () => {
    const selectedCarevan = getValues(validation.fieldNames.carevan)?.data;
    const remainingBed = {
      single: selectedCarevan?.remaining_single_bed,
      double: selectedCarevan?.remaining_double_bed,
      triple: selectedCarevan?.remaining_triple_bed,
    }
    const userData = userStatus?.data?.data?.register;
    console.log({ userData, selectedCarevan })
    // if (
    //   (userData?.members === 2 && !remainingBed.double) ||
    //   (userData?.members === 3 && !remainingBed.triple) ||
    //   userData?.members < 1 ||
    //   userData?.members > 3
    // ) {
    //   return handleSetModalData(userData);
    // }
    // tableSetting.onSelectRow({ ...data, bed: data.members });
    onSubmitCaravan(data?.members);
  }

  const disableFormByStatus = useMemo(() => watchStatusData?.value === 0 || watchStatusData?.value === 7, [watchStatusData])

  const handleConfirmPassport = () => {
    setJustSendPassport(true);
    setValue(validation.fieldNames.passport_sending_status, PASSPORT_SENDING_STATUS[1])
    const reqData = {
      travel_register_id: travelId,
      [validation.fieldNames.status]: acceptFinallyStatus[UserStatusInfoData?.register?.status_num]?.value,
      [validation.fieldNames.sabt_nahayi_status]: sabtNahayiStatus[UserStatusInfoData?.register?.sabt_nahayi_status_num]?.value,
      [validation.fieldNames.dutyStatus]: documentStatus[UserStatusInfoData?.register?.duty_status_num]?.value,
      [validation.fieldNames.identityStatus]: documentStatus[UserStatusInfoData?.register?.identity_status_num]?.value,
      [validation.fieldNames.duty_sending_status]: DUTY_SENDING_STATUS[UserStatusInfoData?.register?.duty_sending_status_num]?.value,

      [validation.fieldNames.duty_from]: UserStatusInfoData?.register?.duty_from ? persianToEnglishNumber(
        fDateForApi(UserStatusInfoData?.register?.duty_from)
      ) : undefined,

      [validation.fieldNames.duty_to]: UserStatusInfoData?.register?.duty_to ? persianToEnglishNumber(
        fDateForApi(UserStatusInfoData?.register?.duty_to)
      ) : undefined,
      // [validation.fieldNames.haj_status]: HAJ_STATUS[UserStatusInfoData?.register?.haj_status]?.value,
      [validation.fieldNames.passport_sending_status]: PASSPORT_SENDING_STATUS[1]?.value,
      [validation.fieldNames.type]: CLIENT_TYPE_OP.find(item => item.value === UserStatusInfoData?.register?.client?.type)?.value,
      [validation.fieldNames.code]: UserStatusInfoData?.register?.code,
      [validation.fieldNames.description]: UserStatusInfoData?.register?.description,
    };

    // console.log('* * * onSubmit : ', { reqData, UserStatusInfoData });
    mutate(reqData);
  }

  const handleSubmitHajStatus = () => {
    const reqData = {
      travel_register_id: travelId,
      [validation.fieldNames.haj_status]: HAJ_STATUS[UserStatusInfoData?.register?.haj_status_num]?.value == 1 ? 0 : 1,
    }
    hajStatusMutate(reqData)
  }



  console.log({ queryParams });
  return (
    <Box
      sx={{
        width: '100%',
        // display: { xs: 'block', md: 'flex' },
        gap: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        p: 4,
      }}
    >

      <ModalLayout ref={confirmSubmitHajStatusModal}>
        <Box
          sx={{
            width: '100%',
            maxWidth: '550px',
            // display: { xs: 'block', md: 'flex' },
            gap: 2,
            bgcolor: 'background.paper',
            borderRadius: 1,
            px: 3,
            py: 2,
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
            }}
          >
            {`ایا از ${UserStatusInfoData?.register?.haj_status_num == 1 ? 'حذف' : "ارسال"} سهمیه ${UserStatusInfoData?.register?.haj_status_num == 1 ? 'از' : "به"} سازمان حج مطمئن هستید؟`}
          </DialogTitle>
          <DialogContentText>
            این فرایند ممکن است چند دقیقه طول بکشد ، لطفا پس از ثبت منتظر بمانید.
          </DialogContentText>
          <DialogActions
            sx={{
              display: 'flex',
              mt: 3,
              gap: 3,
              justifyContent: 'center',
            }}
          >
            <LoadingButton
              fullWidth
              type="click"
              variant="outlined"
              disabled={justHasStatusLoading}
              color="error"
              onClick={handleQuestionModal}
            >
              لغو
            </LoadingButton>
            <LoadingButton
              fullWidth
              type="click"
              variant="contained"
              color="success"
              loading={justHasStatusLoading}
              onClick={handleSubmitHajStatus}
            >
              بله ادامه میدهم
            </LoadingButton>
          </DialogActions>
        </Box>
      </ModalLayout>

      <Modal
        open={toggleModal}
        onClose={handleToggleModal}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 6,
        }}
      >
        <SelectBed
          {...{
            caravan: getValues(validation.fieldNames.carevan)?.data,
            onClose: handleToggleModal,
            onAccept: (data) => {
              console.log('* * * onAccept :', { data });
              // tableSetting.onSelectRow(data);
              onSubmitCaravan(data?.bed);
              handleToggleModal();
            },
            remainingBed: {
              single: getValues(validation.fieldNames.carevan)?.data?.remaining_single_bed,
              double: getValues(validation.fieldNames.carevan)?.data?.remaining_double_bed,
              triple: getValues(validation.fieldNames.carevan)?.data?.remaining_triple_bed,
            },
            data: toggleModal,
          }}
        // onClose={handleQuestionModal}
        />
      </Modal>
      {/* <Box
        sx={{
          textAlign: 'center',
          mb: '30px',
        }}
        onClick={() => navigate(backUrl)}
      >
        <Typography variant="h5">{'شما در حال ایجاد یک دوره جدید هستید!'}</Typography>
      </Box> */}

      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6}>
              <RHFTextField name={validation.fieldNames.name} label={'نام'} />
            </Grid> */}

            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.status}
                label={'وضعیت'}
                options={Object.values(acceptFinallyStatus)}
                disabled={(admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0) && !isAttabat}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.sabt_nahayi_status}
                label={'وضعیت ثبت نهایی'}
                options={Object.values(sabtNahayiStatus)}
                disabled={((admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0) && !isAttabat) || disableFormByStatus}
              />
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.bankStatus}
                label={'وضعیت بانکی'}
                options={Object.values(documentStatus)}
              />
            </Grid> */}
            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.dutyStatus}
                label={'نظام وظیفه'}
                options={Object.values(documentStatus)}
                disabled={disableFormByStatus}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.identityStatus}
                label={'مدارک هویتی'}
                options={Object.values(documentStatus)}
                disabled={disableFormByStatus}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFSelector
                options={CLIENT_TYPE_OP}
                name={validation.fieldNames.type}
                label={"نوع زائر"}
                disabled={disableFormByStatus}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.passport_sending_status}
                label={'وضعیت تحویل گذرنامه'}
                options={Object.values(PASSPORT_SENDING_STATUS)}
                disabled={disableFormByStatus}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFSelector
                name={validation.fieldNames.duty_sending_status}
                label={'وضعیت مجوز خروج از کشور'}
                options={Object.values(DUTY_SENDING_STATUS)}
                disabled={disableFormByStatus || admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFDatePicker
                name={validation.fieldNames.duty_from}
                label={'تاریخ شروع مجوز خروج از کشور'}
                hideClearable
                disabled={disableFormByStatus || admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <RHFDatePicker
                name={validation.fieldNames.duty_to}
                label={'تاریخ پایان مجوز خروج از کشور'}
                hideClearable
                disabled={disableFormByStatus || admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              {/* <RHFSelector
                name={validation.fieldNames.haj_status}
                label={'وضعیت در سازمان حج'}
                options={Object.values(HAJ_STATUS)}
                disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0}
              /> */}

              {/* { ?
                <LoadingButton variant="contained" color={'error'} loading={isLoading}
                  sx={{ width: "100%", py: 2 }}
                  disabled={(!hasAccess(accessStatus.update)) || (admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0)}
                >
                  حذف سهمیه سازمان حج
                </LoadingButton>
                :
              } */}
             
              <LoadingButton
                variant="contained"
                color={HAJ_STATUS?.[UserStatusInfoData?.register?.haj_status_num]?.color || "info"}
                loading={justHasStatusLoading}
                sx={{ width: "100%", py: 2, boxShadow: "none" }}
                onClick={handleQuestionModal}
                disabled={(!hasAccess(accessStatus.update)) || (admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0)}
              >
                {HAJ_STATUS?.[UserStatusInfoData?.register?.haj_status_num]?.text}
              </LoadingButton>

              {(UserStatusInfoData?.register?.haj_last_error && [HAJ_STATUS?.[1]?.value , HAJ_STATUS?.[2]?.value]?.findIndex(findItem => findItem == UserStatusInfoData?.register?.haj_status_num) === -1) ? (
                <Typography color="red" sx={{mt:2 , fontSize : 12 , whiteSpace:"pre-wrap"}}>{UserStatusInfoData?.register?.haj_last_error}</Typography>
              ) : null}


            </Grid>
            <Grid item xs={12} md={12}>
              <RHFTextField
                name={validation.fieldNames.code}
                label={'کد بازیابی'}
                disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0 || disableFormByStatus}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <RHFTextField
                name={validation.fieldNames.description}
                label={'توضیحات'}
                multiline
                rows={4}
                disabled={admin?.role?.title?.trim() === "عامل استانی" || admin?.role?.title?.trim() === "استان" || admin?.province?.length > 0 || disableFormByStatus}
              />
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{
            display: 'flex',
            mt: 3,
            gap: 3,
            justifyContent: 'center',
          }}
        >
          {/* <LoadingButton
            fullWidth
            // type="click"
            variant="outlined"
            color="success"
            loading={isLoading}
            onClick={onClose}
          >
            {'لغو'}
          </LoadingButton> */}

          {hasAccess(accessStatus.update) &&
            <>
              <LoadingButton type="submit" variant="contained" color={'success'} loading={isLoading}>
                {'ثبت اطلاعات'}
              </LoadingButton>
            </>
          }

        </Box>
      </FormProvider>


      {(!disableFormByStatus && (UserStatusInfoData?.register?.passport_sending_status_num === 0)) && (
        <Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              p: 2,
              backgroundColor: 'grey.main',
              borderRadius: '8px',
              my: 3
            }}
          >
            <Typography>تایید گذرنامه</Typography>

          </Box>

          <Box
            sx={{
              display: 'flex',
              mt: 3,
              gap: 3,
              justifyContent: 'center',
            }}
          >

            <LoadingButton variant="contained" color={'success'} loading={isLoading} onClick={handleConfirmPassport}>
              {'تایید'}
            </LoadingButton>

          </Box>


        </Box>
      )}


      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmitCaravan)}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            p: 2,
            backgroundColor: 'grey.main',
            borderRadius: '8px',
            my: 3
          }}
        >
          <Typography>انتخاب کاروان</Typography>

        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <CaravanSelector.Element
              name={validation.fieldNames.carevan}
              queryParams={{
                travel_id: searchParams.get("travel")
              }}
              label={'کاروان'}
              disabled={HasCaravan || disableFormByStatus}
            />
          </Grid>
        </Grid>
      </FormProvider>
      <Box
        sx={{
          display: 'flex',
          mt: 3,
          gap: 3,
          justifyContent: 'center',
        }}
      >

        {hasAccess(accessStatus.update) &&
          <>
            {HasCaravan ?
              <>
                <LoadingButton variant="contained" color={'error'} loading={mutateAdd?.isLoading || isLoading} onClick={() => onSubmitCaravan(0)}>
                  {'حذف از کاروان'}
                </LoadingButton>
              </>
              :
              <>
                <LoadingButton variant="contained" color={'success'} loading={mutateAdd?.isLoading || isLoading} onClick={handleSelectBed}>
                  {'اضافه کردن به کاروان'}
                </LoadingButton>
              </>
            }
          </>
        }

      </Box>
    </Box>
  );
};

export default UserStatusInfo;
